<template>
  <div class="el-upload-list--picture-card">
    <el-upload
      v-for="(item, index) in imgList"
      :key="index"
      class="avatar-uploader"
      :action="uploadUrl"
      :show-file-list="false"
      v-loading="uploading[index]"
      :disabled="disabled"
      :on-success="handleAvatarSuccess"
      :on-error="handlerError"
      :before-upload="beforeAvatarUpload"
      :headers="{ Authorization: getToken() }"
      :data="{ busType: 'file/business' }"
      @click.native="setIndex(index)"
    >
      <el-image
        ref="preview"
        v-if="fileList && fileList[index] && fileList[index].fid"
        :src="imageUrl(fileList[index])"
        :preview-src-list="[imageUrl(fileList[index])]"
        class="avatar"
      />
      <img v-else-if="item.backgroundImage" :src="item.backgroundImage" class="avatar-bg" />
      <i
        v-if="fileList && (!fileList[index] || !fileList[index].fid)"
        class="el-icon-plus avatar-uploader-icon"
      />
      <div v-if="fileList && (!fileList[index] || !fileList[index].fid)">
        {{ item.title }}
      </div>
      <span
        v-if="fileList && fileList[index] && fileList[index].fid"
        class="el-upload-list__item-actions"
        @click.stop="stop()"
      >
        <span
          class="el-upload-list__item-preview"
          @click="handlePictureCardPreview(index)"
        >
          <i class="el-icon-zoom-in" />
        </span>
        <span
          class="el-upload-list__item-downl"
          @click="handleDownload(fileList[index])"
        >
          <i class="el-icon-download"></i>
        </span>
        <span
          v-if="!disabled"
          class="el-upload-list__item-delete"
          @click="handleRemove(index)"
        >
          <i class="el-icon-delete" />
        </span>
      </span>
      <template slot="tip">
        <div class="avatar-uploader-tip">{{ item.tip }}</div>
      </template>
    </el-upload>
    <el-dialog :visible.sync="dialogVisible" append-to-body>
      <img width="100%" :src="dialogImageUrl" />
    </el-dialog>
  </div>
</template>

<script>
import { getToken } from "@/utils/auth";
import { download } from "@/api/data";
import { isForbiddenFile, getForbiddenFileTip } from "@/utils/fileType";

export default {
  name: "ImgList",
  props: {
    value: Array,
    imgList: {
      type: Array,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    accept: {
      type: Array,
      default: () => {
        return ["jpg", "png", "jpeg", "bmp", "pdf"];
      },
    },
  },
  data() {
    return {
      fileList: this.value,
      curIndex: 0,
      dialogImageUrl: "",
      dialogVisible: false,
      uploading: this.imgList.map(item => false),
    };
  },
  computed: {
    uploadUrl() {
      return process.env.VUE_APP_BASE_API + "/api/manage/file/upload";
    },
  },
  watch: {
    value(val) {
      this.fileList = val;
    },
  },
  methods: {
    handleAvatarSuccess(res, file) {
      this.uploading[file.raw.loadingIndex]=false
      this.fileList[file.raw.loadingIndex] = Object.assign(res.data, {
        fileType: this.imgList[file.raw.loadingIndex].fileType,
      });
      this.$emit("input", this.fileList, file.raw.loadingIndex);
      this.$forceUpdate();
    },
    handlerError(err, file, fileList) {
      this.uploading[file.raw.loadingIndex] = false
      this.$forceUpdate()
    },
    beforeAvatarUpload(file) {
      // 拦截 html/svg/js/xml/exe/jsp 等存在脚本执行风险的文件类型
      if (isForbiddenFile(file)) {
        this.$notify({
          title: getForbiddenFileTip(file),
          type: "warning",
        });
        return false;
      }
      const arr = file.name.split(".");
      const type = arr[arr.length - 1].toLowerCase();
      if (this.accept.length > 0) {
        if (this.accept.indexOf(type) == -1) {
          this.$notify({
            title: `只能上传${this.accept.join(",")}格式的图片`,
            type: "warning",
          });
          return false;
        }
      }
      this.uploading[this.curIndex]=true
      this.uploading=[...this.uploading]
      file.loadingIndex = this.curIndex
    },
    imageUrl(fileInfo) {
      //oss文件
      if (fileInfo.fileUrl && fileInfo.fileUrl.indexOf("aliyuncs") >= 0) {
        return fileInfo.fileUrl;
      }

      // const data = {
      //   result: null
      // }
      // await download(process.env.VUE_APP_BASE_API + '/api/manage/file/download/' + fileInfo.fid).then(data => {
      //   data.result = data
      // }).catch(() => {})

      // return data.result;
      return (
        process.env.VUE_APP_BASE_API +
        "/api/manage/file/download/" +
        fileInfo.fid
      );
    },
    setIndex(index) {
      this.curIndex = index;
    },
    getToken() {
      return getToken();
    },
    handlePictureCardPreview(index) {
      // this.dialogImageUrl = this.imageUrl(this.fileList[index]);
      this.$refs.preview[index].clickHandler()
    },
    showImg(url) {
      this.imgExpand = url;
      this.dialogImg = true;
    },
    handleRemove(index) {
      this.$set(this.fileList, index, null)
      this.$emit("input", this.fileList, index);
    },
    handleDownload(fileInfo) {
      window.open(fileInfo.fileUrl);
    },
    stop() {
      return false;
    },
  },
};
</script>

<style>
.el-upload-list--picture-card {
  display: inline-flex !important;
}
.avatar-uploader {
  display: inline-block;
  margin-right: 10px;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 148px;
  height: 148px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
.avatar {
  width: 148px;
  display: block;
}
.avatar-bg {
  width: 100%;
  height: 100%;
  position: absolute;
  opacity: .5;
}
.avatar-uploader-tip {
  text-align: center;
}
.el-upload:hover .img-hover {
  display: block;
}
.img-hover {
  width: 148px;
  height: 148px;
  background: rgba(29, 29, 30, 0.7);
  position: absolute;
  top: 0;
  left: 0;
  display: none;
}
</style>
